// extracted by mini-css-extract-plugin
module.exports = {"dragging":"css_dragging__2kUYW","root":"css_root__X11Bu","dragged":"css_dragged__2MlRt"};